module.exports = __webpack_public_path__ + "static/media/olsLocation.b50743ea.svg";